import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/finance/outgoing-payment/";

export function saveOutgoingPayment(outgoingPayment) {
  return http.post(apiEndpoint, outgoingPayment);
}

export function getOutgoingPayments() {
  return http.get(apiEndpoint);
}

export function getOutgoingPaymentDetail(paymentID) {
  return http.get(apiEndpoint + "payment-detail/" + paymentID);
}

export function getOutgoingPaymentByInvoice(invoiceID) {
  return http.get(apiEndpoint + "invoice-payments/" + invoiceID);
}

export function cancelOutgoingPayment(invoiceID) {
  return http.delete(apiEndpoint + invoiceID);
}

export function getOutgoingPaymentDocRef() {
  return http.get(apiEndpoint + "payment-doc-ref");
}
